import httpClient from "@/services/http.service"
import axios from "axios";

const signingDocumentService = {
    getDocumentsForSigning() {
        return httpClient.get(`syllabus_data/syllabus-sign/index`)
    },
}

export default signingDocumentService